import { branchTermSingular } from 'utils/terminology';
import UnorderedList from 'components/ui-components/UnorderedList';
import { ClassicTick } from 'assets/icons';
import { ctaGreen } from 'constants/variables';
import { useNavigate } from 'react-router-dom';
import Card from 'components/ui-components/Card';
import RegisterCtaCardTemplate from '../RegisterCtaCardTemplate';

const Welcome = () => {
  const navigate = useNavigate();

  const cards = [
    {
      title: 'Already have an account?',
      paragraph: `If you already have a CEF account in-${branchTermSingular}, you will need to activate it first before you can use it to shop online.`,
      button: {
        text: 'Activate your Account',
        handleClick: () => {
          window.location.href = '/mycef/account/new?account=true';
        },
      },
      underButton: (
        <span className="mt-10 fw-400 tc-secondary">
          Already have an online account?&nbsp;
          <a className="td-u" href="/session/new">
            Sign in
          </a>
        </span>
      ),
    },
    {
      title: 'Create a Trade account',
      paragraph:
        'Create your CEF trade account in minutes and start ordering today.',
      body: (
        <>
          <UnorderedList
            className="fw-400 tc-main"
            hasIcon
            IconImage={ClassicTick}
            iconColor={ctaGreen}
            iconWidth={14}
            iconHeight={11}
            listItems={[
              'Credit facilities*',
              'Monthly statements',
              'VAT approved itemised invoices',
            ]}
          />
          <small className="fw-400 fs-11 tc-secondary">
            *Subject to credit checks
          </small>
        </>
      ),
      button: {
        text: 'Create an Account',
        handleClick: () => navigate('step1'),
      },
    },
  ];

  return (
    <div className="register-entrance fl fl-col m-fl-row m-jc-c g-20">
      {cards.map(({ title, paragraph, body, button, underButton }) => (
        <Card
          key={title}
          variant="small"
          className="register-entrance__item fl fl-col jc-sb">
          <RegisterCtaCardTemplate
            title={title}
            paragraph={paragraph}
            body={body}
            button={button}
            underButton={underButton}
          />
        </Card>
      ))}
    </div>
  );
};

export default Welcome;
